import { DffOprindeligAktuelVaerdi, EntitetStatus } from "@dffedb/util";

export class Ejendomsfaktor {
    public definitionId: number;
    public id: number;
    public status: EntitetStatus;
    public vaerdi: DffOprindeligAktuelVaerdi<string>;
}
